/* Round 4 selected composition. Requires the completed Round 3 adapter.
 * Text and existing controls are moved, never recreated. No new product copy.
 */
(function () {
  'use strict';
  function make(name, tag) {
    var node = document.createElement(tag || 'div');
    node.className = name;
    return node;
  }
  function textNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var list = [], node;
    while ((node = walker.nextNode())) {
      if (!node.parentElement.closest('[data-round3-ui], script, style')) list.push({ node: node, value: node.nodeValue });
    }
    return list;
  }
  function capsule(root) {
    var source = root.querySelector('#hmc-s20 img[src*="/assets/"], img[src*="/assets/"]');
    if (!source) return null;
    var src;
    try { src = new URL('hm-pdp-feature-1.jpg', source.src).href; }
    catch (error) { return null; }
    var image = document.createElement('img');
    image.src = src;
    image.alt = '';
    image.setAttribute('aria-hidden', 'true');
    image.loading = 'lazy';
    image.decoding = 'async';
    image.width = 1672;
    image.height = 941;
    return image;
  }
  function contextSection(root) {
    if (root.dataset.hmcServerLayout) return;
    var source = root.querySelector('#hmc-s14');
    var context = source && source.querySelector('.hmc-rs-context');
    if (!context) return;
    var section = make('hmc-sec hmc-r4-context', 'section');
    section.id = 'hmc-s14-context';
    var inner = make('hmc-r4-context-inner');
    var head = make('hmc-r4-context-head');
    var lead = context.querySelector('p');
    if (lead) {
      if (!lead.id) lead.id = 'hmc-r4-context-heading';
      section.setAttribute('aria-labelledby', lead.id);
      head.appendChild(lead);
    }
    context.classList.add('hmc-r4-context-copy');
    inner.appendChild(head);
    var image = capsule(root);
    if (image) {
      var visual = make('hmc-r4-context-image');
      visual.appendChild(image);
      inner.appendChild(visual);
    }
    inner.appendChild(context);
    section.appendChild(inner);
    source.insertAdjacentElement('afterend', section);
  }
  function alternativesImage(root) {
    if (root.dataset.hmcServerLayout) return;
    var alternative = root.querySelector('#hmc-s17 .hmc-whynot');
    var heading = alternative && alternative.querySelector('h3');
    var image = capsule(root);
    if (!alternative || !heading || !image) return;
    var visual = make('hmc-r4-alternatives-image');
    visual.appendChild(image);
    heading.insertAdjacentElement('afterend', visual);
  }
  function statsLayout(root) {
    var wrap = root.querySelector('#hmc-s22 > .hmc-wrap');
    if (!wrap) return;
    var stats = wrap.querySelector('.hmc-stats');
    if (!stats) return;
    var copy = make('hmc-r4-stats-copy');
    Array.from(wrap.childNodes).forEach(function (node) {
      if (node !== stats) copy.appendChild(node);
    });
    wrap.insertBefore(copy, stats);
  }
  function selectedCouple(root) {
    if (root.dataset.hmcServerLayout) return;
    var image = root.querySelector('#hmc-s28 .hmc-imgcard > img');
    if (!image || !image.src) return;
    try {
      image.dataset.round4OriginalSrc = image.src;
      image.src = new URL('hmc-r5-couple.png', image.src).href;
      image.removeAttribute('srcset');
      image.width = 1125;
      image.height = 1398;
      image.dataset.round4Image = 'couple-realistic';
    } catch (error) { /* Keep the original image if its source is unavailable. */ }
  }
  function selectedSectionImages(root) {
    if (root.dataset.hmcServerLayout) return;
    [
      ['#hmc-s14 .hmc-r3m-science-image img', 'hmc-r4-gp.png', 'Microscope and slide in a laboratory', 1448, 1086],
      ['#hmc-s26 .hmc-r3m-runner-image img', 'hmc-r4-runner.png', 'An active older man taking a break in a park', 1536, 1024],
      ['#hmc-s15 .hmc-cc img', 'hmc-r5-fibrin.png', 'Illustration of red blood cells within a fibrin network', 1448, 1086],
      ['#hmc-s16 .hmc-r3m-failure-photo img', 'hmc-r5-routines.png', 'Supplement bottles, beetroot juice, a meal and walking shoes', 1448, 1086],
      ['#hmc-s23 .hmc-imgcard img', 'hmc-r5-japan.png', 'Hand holding Holtmore Nattokinase beside a lake with Mount Fuji in the background', 1448, 1086]
    ].forEach(function (entry) {
      var image = root.querySelector(entry[0]);
      if (!image || !image.src) return;
      try {
        image.dataset.round4OriginalSrc = image.src;
        image.dataset.round4OriginalAlt = image.alt;
        image.src = new URL(entry[1], image.src).href;
        image.removeAttribute('srcset');
        var picture = image.closest('picture');
        if (picture) picture.querySelectorAll('source').forEach(function (source) {
          source.dataset.round4OriginalSrcset = source.getAttribute('srcset') || '';
          source.setAttribute('srcset', image.src);
        });
        image.alt = entry[2];
        image.width = entry[3];
        image.height = entry[4];
        image.dataset.round4Image = entry[1];
      } catch (error) { /* Keep the existing image if its source is unavailable. */ }
    });
  }
  function variantBar(root) {
    if (new URLSearchParams(window.location.search).get('review') !== '1') return;
    var bar = root.querySelector('.hmc-r3-variantbar');
    if (!bar) {
      bar = make('hmc-r3-variantbar hmc-r3-controls', 'nav');
      bar.dataset.round3Ui = '';
      bar.setAttribute('aria-label', 'Design variants');
      ['a', 'b', 'c'].forEach(function (mode) {
        var link = document.createElement('a');
        var url = new URL(window.location.href);
        url.searchParams.set('design', mode);
        url.searchParams.set('preview_theme_id', document.body.getAttribute('data-hm-theme'));
        link.href = url.href;
        link.textContent = 'Design ' + mode.toUpperCase();
        bar.appendChild(link);
      });
      root.prepend(bar);
    }
    bar.querySelectorAll('a').forEach(function (link) { link.setAttribute('aria-current', 'false'); });
    var selected = document.createElement('a');
    var url = new URL(window.location.href);
    url.searchParams.set('design', 'selected');
    url.searchParams.set('preview_theme_id', document.body.getAttribute('data-hm-theme'));
    selected.href = url.href;
    selected.textContent = 'Ausgewählt';
    selected.dataset.round3Ui = '';
    selected.setAttribute('aria-current', 'page');
    bar.prepend(selected);
  }
  window.HmcRound4 = function (root, options) {
    if (!root) return { pending: true, reason: 'No product root' };
    var mode = options && options.mode;
    if (!mode) mode = new URLSearchParams(window.location.search).get('design');
    if (/^[abc]$/.test(mode || '')) return { archived: true, mode: mode };
    if (root.__hmcRound4Audit) return root.__hmcRound4Audit;
    if (!root.querySelector('.hmc-r3m-science') || !root.querySelector('.hmc-r3-week-card')) {
      return { pending: true, reason: 'Round 3 layout is not ready' };
    }
    var texts = textNodes(root);
    var controls = Array.from(root.querySelectorAll('a, button, input, select, textarea, summary, video'));
    root.classList.add('hmc-design-round4');
    root.dataset.design = 'selected';
    contextSection(root);
    alternativesImage(root);
    statsLayout(root);
    selectedCouple(root);
    selectedSectionImages(root);
    variantBar(root);
    var after = textNodes(root);
    var lost = texts.filter(function (entry) { return !root.contains(entry.node); });
    var changed = texts.filter(function (entry) { return entry.node.nodeValue !== entry.value; });
    var audit = {
      mode: 'selected', textNodesBefore: texts.length, textNodesAfter: after.length,
      textNodesLost: lost.length, textNodesChanged: changed.length,
      controlsBefore: controls.length,
      controlsLost: controls.filter(function (node) { return !root.contains(node); }).length,
      passed: !lost.length && !changed.length && after.length === texts.length && controls.every(function (node) { return root.contains(node); })
    };
    root.dataset.round4Ready = 'true';
    root.__hmcRound4Audit = audit;
    return audit;
  };
}());

/* Lower-section layout only. Existing content is moved, never cloned or rewritten. */
(function () {
  'use strict';
  var carouselSequence = 0;

  function ui(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    node.setAttribute('data-round3-ui', '');
    return node;
  }

  /** Native scrolling helper shared with the upper video carousel. */
  window.HmcRound3Carousel = function (root, trackOrSelector, options) {
    options = options || {};
    var track = typeof trackOrSelector === 'string' ? root.querySelector(trackOrSelector) : trackOrSelector;
    if (!track) return null;
    if (track.__hmcRound3Carousel) {
      track.__hmcRound3Carousel.refresh();
      return track.__hmcRound3Carousel;
    }
    var cards = Array.from(track.children).filter(function (node) { return !node.hasAttribute('data-round3-ui'); });
    if (!cards.length) return null;
    track.classList.add('hmc-r3-track');
    if (!track.id) track.id = 'hmc-r3-carousel-' + (++carouselSequence);
    if (!track.hasAttribute('tabindex')) track.tabIndex = 0;
    track.setAttribute('role', 'region');
    track.setAttribute('aria-roledescription', 'carousel');
    var section = track.closest('section');
    var heading = section && section.querySelector('h2');
    if (heading) {
      if (!heading.id) heading.id = track.id + '-heading';
      track.setAttribute('aria-labelledby', heading.id);
    } else {
      track.setAttribute('aria-label', options.label || 'Cards');
    }

    var controls = ui('div', 'hmc-r3-controls');
    var prev = ui('button');
    var counter = ui('output');
    var next = ui('button');
    prev.type = next.type = 'button';
    prev.textContent = '←';
    next.textContent = '→';
    prev.setAttribute('aria-label', 'Previous card');
    next.setAttribute('aria-label', 'Next card');
    prev.setAttribute('aria-controls', track.id);
    next.setAttribute('aria-controls', track.id);
    counter.setAttribute('aria-live', 'polite');
    counter.setAttribute('aria-atomic', 'true');
    controls.append(prev, counter, next);
    if (options.controlsMount) options.controlsMount.appendChild(controls);
    else track.insertAdjacentElement('afterend', controls);

    var frame = 0;
    var observer;
    var disposed = false;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function maximum() { return Math.max(0, track.scrollWidth - track.clientWidth); }
    function offsets() {
      var origin = track.getBoundingClientRect().left + track.clientLeft;
      return cards.map(function (card) { return card.getBoundingClientRect().left - origin + track.scrollLeft; });
    }
    function selectedIndex() {
      var max = maximum();
      if (max < 2 || track.scrollLeft < 2) return 0;
      if (track.scrollLeft >= max - 2) return cards.length - 1;
      var points = offsets();
      var best = 0;
      points.forEach(function (point, index) {
        if (Math.abs(point - track.scrollLeft) < Math.abs(points[best] - track.scrollLeft)) best = index;
      });
      return best;
    }
    function update() {
      frame = 0;
      if (disposed) return;
      var max = maximum();
      var index = selectedIndex();
      prev.disabled = max < 2 || track.scrollLeft <= 2;
      next.disabled = max < 2 || track.scrollLeft >= max - 2;
      var value = (index + 1) + ' / ' + cards.length;
      if (counter.textContent !== value) counter.textContent = value;
      controls.dataset.current = String(index + 1);
      controls.dataset.total = String(cards.length);
    }
    function schedule() {
      if (!frame && !disposed) frame = requestAnimationFrame(update);
    }
    function goTo(position) {
      track.scrollTo({ left: Math.min(maximum(), Math.max(0, position)), behavior: reduced.matches ? 'instant' : 'smooth' });
      schedule();
    }
    function step(direction) {
      var points = offsets();
      var stride = points.length > 1 ? points[1] - points[0] : track.clientWidth;
      goTo(track.scrollLeft + direction * stride);
    }
    function previous() { step(-1); }
    function following() { step(1); }
    function onKey(event) {
      if (event.target !== track || event.altKey || event.ctrlKey || event.metaKey) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); previous(); }
      else if (event.key === 'ArrowRight') { event.preventDefault(); following(); }
      else if (event.key === 'Home') { event.preventDefault(); goTo(0); }
      else if (event.key === 'End') { event.preventDefault(); goTo(maximum()); }
    }
    prev.addEventListener('click', previous);
    next.addEventListener('click', following);
    track.addEventListener('scroll', schedule, { passive: true });
    track.addEventListener('keydown', onKey);
    window.addEventListener('resize', schedule, { passive: true });
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(schedule);
      observer.observe(track);
      cards.forEach(function (card) { observer.observe(card); });
    }
    var api = {
      track: track,
      controls: controls,
      refresh: schedule,
      next: following,
      previous: previous,
      scrollToIndex: function (index) {
        var points = offsets();
        goTo(points[Math.min(points.length - 1, Math.max(0, index))] || 0);
      },
      destroy: function () {
        disposed = true;
        if (frame) cancelAnimationFrame(frame);
        if (observer) observer.disconnect();
        window.removeEventListener('resize', schedule);
        track.removeEventListener('scroll', schedule);
        track.removeEventListener('keydown', onKey);
        prev.removeEventListener('click', previous);
        next.removeEventListener('click', following);
        controls.remove();
        delete track.__hmcRound3Carousel;
      }
    };
    track.__hmcRound3Carousel = api;
    update();
    return api;
  };

  function textNodes(root) {
    var values = [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      var node = walker.currentNode;
      if (!node.parentElement || node.parentElement.closest('[data-round3-ui],.hmc-r3-controls,script,style,noscript')) continue;
      var value = node.nodeValue.replace(/\s+/g, ' ').trim();
      if (value) values.push(value);
    }
    return values.sort();
  }
  function wrapContents(parent, className, exclude) {
    var wrapper = document.createElement('div');
    wrapper.className = className;
    var nodes = Array.from(parent.childNodes).filter(function (node) { return node !== exclude; });
    nodes.forEach(function (node) { wrapper.appendChild(node); });
    parent.appendChild(wrapper);
    return wrapper;
  }
  function inner(root, id) {
    var section = root.querySelector('#hmc-s' + id);
    return section && section.querySelector(':scope > .hmc-wrap');
  }
  function split(root, id, className, imageFirst) {
    var wrap = inner(root, id);
    if (!wrap || wrap.querySelector(':scope > .' + className)) return;
    var image = wrap.querySelector(':scope > .hmc-imgcard');
    if (!image) return;
    var copy = wrapContents(wrap, className, image);
    if (!imageFirst) wrap.insertBefore(copy, image);
  }

  /** Call after the parent's explicitly approved source cuts and top-level grouping. */
  window.HmcRound3Lower = function (root) {
    if (!root) return null;
    if (root.__hmcRound3Lower) {
      root.__hmcRound3Lower.carousels.forEach(function (carousel) { carousel.refresh(); });
      return root.__hmcRound3Lower;
    }
    var before = textNodes(root);
    root.querySelectorAll('#hmc-s18 .hmc-week').forEach(function (week) {
      if (week.querySelector(':scope > .hmc-r3-week-card')) return;
      var phase = week.querySelector('.hmc-week__k');
      if (phase) week.insertBefore(phase, week.firstChild);
      wrapContents(week, 'hmc-r3-week-card', phase);
    });

    var statsWrap = inner(root, 22);
    var stats = statsWrap && statsWrap.querySelector(':scope > .hmc-stats');
    if (stats) {
      ['.hmc-statline', '.hmc-cta', '.hmc-under-cta'].forEach(function (selector) {
        var node = statsWrap.querySelector(':scope > ' + selector);
        if (node) statsWrap.insertBefore(node, stats);
      });
    }
    split(root, 24, 'hmc-r3-explainer-copy', true);
    split(root, 28, 'hmc-r3-split-copy', false);
    split(root, 30, 'hmc-r3-split-copy', false);

    var guarantee = inner(root, 29);
    if (guarantee && !guarantee.querySelector(':scope > .hmc-r3-guarantee-copy')) {
      var seal = guarantee.querySelector(':scope > .hmc-gseal');
      if (seal) wrapContents(guarantee, 'hmc-r3-guarantee-copy', seal);
    }
    var faqWrap = inner(root, 31);
    if (faqWrap && !faqWrap.querySelector(':scope > .hmc-r3-faq-intro')) {
      var faq = faqWrap.querySelector(':scope > .hmc-faq');
      if (faq) {
        var intro = wrapContents(faqWrap, 'hmc-r3-faq-intro', faq);
        faqWrap.insertBefore(intro, faq);
        faq.querySelectorAll('details').forEach(function (detail) { detail.open = false; });
      }
    }

    var carousels = [
      window.HmcRound3Carousel(root, '#hmc-s20 .hmc-studies', { label: 'Research studies' }),
      window.HmcRound3Carousel(root, '#hmc-s25 .hmc-reasons', { label: 'Reasons' })
    ].filter(Boolean);
    var after = textNodes(root);
    var audit = {
      passed: before.length === after.length && before.every(function (value, index) { return value === after[index]; }),
      originalTextNodes: before.length,
      retainedTextNodes: after.length,
      controlsExcluded: '[data-round3-ui]',
      carousels: carousels
    };
    root.__hmcRound3LowerAudit = { passed: audit.passed, originalTextNodes: before.length, retainedTextNodes: after.length };
    root.__hmcRound3Lower = audit;
    if (!audit.passed) console.error('Round 3 lower layout text-node integrity check failed.');
    return audit;
  };
})();

(function () {
  'use strict';

  function make(className, tagName) {
    var el = document.createElement(tagName || 'div');
    el.className = className;
    return el;
  }

  function children(el) { return Array.from(el.children); }
  function moveRest(source, destination, exclusions) {
    Array.from(source.childNodes).forEach(function (node) {
      if (exclusions.indexOf(node) === -1) destination.appendChild(node);
    });
  }

  function setPhotoVariable(root, name, image, fileName) {
    if (!image || !image.src) return;
    var src = image.src;
    if (fileName) {
      try { src = new URL(fileName, image.src).href; } catch (error) { return; }
    }
    root.style.setProperty(name, 'url("' + src.replace(/"/g, '%22') + '")');
  }

  function science(root) {
    var section = root.querySelector('#hmc-s14');
    if (!section || section.dataset.r3Middle) return;
    var wrap = section.querySelector('.hmc-wrap');
    if (!wrap) return;
    var picture = wrap.querySelector('.hmc-imgcard');
    var title = wrap.querySelector('h2');
    var lead = wrap.querySelector('.hmc-lead');
    var head = make('hmc-r3m-science-head');
    var copy = make('hmc-r3m-science-copy');
    if (title) head.appendChild(title);
    if (lead) head.appendChild(lead);
    if (picture) picture.classList.add('hmc-r3m-science-image');
    moveRest(wrap, copy, [picture]);
    wrap.classList.add('hmc-r3m-science');
    wrap.appendChild(head);
    if (picture) wrap.appendChild(picture);
    wrap.appendChild(copy);
    var context = section.parentElement.querySelector('.hmc-rs-context');
    if (context && !section.contains(context)) {
      context.classList.add('hmc-r3m-science-context');
      wrap.appendChild(context);
    }
    section.dataset.r3Middle = 'science';
  }

  function mechanism(root) {
    var section = root.querySelector('#hmc-s15');
    if (!section || section.dataset.r3Middle) return;
    var wrap = section.querySelector('.hmc-wrap');
    if (!wrap) return;
    var figure = wrap.querySelector('.hmc-cc');
    var steps = wrap.querySelector('.hmc-steps');
    var head = make('hmc-r3m-mechanism-head');
    var footer = make('hmc-r3m-mechanism-footer');
    children(wrap).filter(function (el) {
      return el.tagName === 'H2' || el.classList.contains('hmc-chip-eyebrow');
    }).forEach(function (el) { head.appendChild(el); });
    if (figure) figure.classList.add('hmc-r3m-mechanism-figure');
    if (steps) steps.classList.add('hmc-r3m-mechanism-steps');
    moveRest(wrap, footer, [figure, steps]);
    wrap.classList.add('hmc-r3m-mechanism');
    wrap.appendChild(head);
    if (figure) wrap.appendChild(figure);
    if (steps) wrap.appendChild(steps);
    wrap.appendChild(footer);
    section.dataset.r3Middle = 'mechanism';
  }

  function failures(root) {
    var section = root.querySelector('#hmc-s16');
    if (!section || section.dataset.r3Middle) return;
    var wrap = section.querySelector('.hmc-wrap');
    if (!wrap) return;
    var cards = wrap.querySelector('.hmc-fails');
    var table = wrap.querySelector('.hmc-symp');
    var head = make('hmc-r3m-failure-head');
    var stage = make('hmc-r3m-failure-stage');
    var dark = make('hmc-r3m-failure-dark');
    var darkInner = make('hmc-r3m-inner');
    var symptoms = make('hmc-r3m-symptoms');
    var symptomsInner = make('hmc-r3m-inner');
    children(wrap).filter(function (el) {
      return el.tagName === 'H2' || el.classList.contains('hmc-chip-eyebrow');
    }).forEach(function (el) { head.appendChild(el); });
    var sourceImage = root.querySelector('#hmc-s23 img');
    if (sourceImage) {
      var photo = make('hmc-r3m-failure-photo');
      var image = document.createElement('img');
      image.src = sourceImage.src;
      image.alt = '';
      image.loading = 'lazy';
      image.width = Number(sourceImage.getAttribute('width')) || 1122;
      image.height = Number(sourceImage.getAttribute('height')) || 1402;
      photo.setAttribute('aria-hidden', 'true');
      photo.appendChild(image);
      stage.appendChild(photo);
    }
    if (cards) stage.appendChild(cards);
    darkInner.appendChild(head);
    darkInner.appendChild(stage);
    dark.appendChild(darkInner);
    if (table) symptomsInner.appendChild(table);
    moveRest(wrap, symptomsInner, []);
    symptoms.appendChild(symptomsInner);
    wrap.classList.add('hmc-r3m-failure-wrap');
    wrap.appendChild(dark);
    wrap.appendChild(symptoms);
    section.dataset.r3Middle = 'failures';
  }

  function comparison(root) {
    var section = root.querySelector('#hmc-s17');
    if (!section || section.dataset.r3Middle) return;
    var wrap = section.querySelector('.hmc-wrap');
    if (!wrap) return;
    var table = wrap.querySelector('.hmc-cmp');
    var alternative = wrap.querySelector('.hmc-whynot');
    var intro = make('hmc-r3m-comparison-intro');
    var tableScroll = make('hmc-r3m-comparison-scroll');
    var compare = make('hmc-r3m-comparison-main');
    var compareInner = make('hmc-r3m-inner');
    var alt = make('hmc-r3m-alternatives');
    var altInner = make('hmc-r3m-inner');
    var altCopy = make('hmc-r3m-alternatives-copy');
    var altAction = make('hmc-r3m-alternatives-action');
    var heading = wrap.querySelector('h2');
    if (heading) {
      if (!heading.id) heading.id = 'hmc-r3-comparison-heading';
      tableScroll.setAttribute('aria-labelledby', heading.id);
    }
    tableScroll.setAttribute('role', 'region');
    tableScroll.setAttribute('tabindex', '0');
    children(wrap).some(function (el) {
      if (el === table) return true;
      intro.appendChild(el);
      return false;
    });
    if (table) {
      var header = table.querySelector('thead tr');
      if (header) {
        var corner = document.createElement('th');
        corner.className = 'hmc-r3m-table-corner';
        corner.setAttribute('aria-hidden', 'true');
        header.insertBefore(corner, header.firstChild);
      }
      Array.from(table.querySelectorAll('tbody tr.is-rl')).forEach(function (row) {
        var label = row.querySelector('th');
        var valueRow = row.nextElementSibling;
        if (!label || !valueRow) return;
        label.removeAttribute('colspan');
        label.setAttribute('scope', 'row');
        label.classList.add('hmc-r3m-row-label');
        valueRow.insertBefore(label, valueRow.firstChild);
        // The original row now contains only layout whitespace, not copy.
        row.remove();
      });
      tableScroll.appendChild(table);
    }
    compareInner.appendChild(intro);
    compareInner.appendChild(tableScroll);
    compare.appendChild(compareInner);
    if (alternative) altCopy.appendChild(alternative);
    var bigEnd = wrap.querySelector('.hmc-bigend');
    if (bigEnd) altCopy.appendChild(bigEnd);
    moveRest(wrap, altAction, []);
    altInner.appendChild(altCopy);
    altInner.appendChild(altAction);
    alt.appendChild(altInner);
    wrap.classList.add('hmc-r3m-comparison-wrap');
    wrap.appendChild(compare);
    wrap.appendChild(alt);
    section.dataset.r3Middle = 'comparison';
  }

  function runner(root) {
    var section = root.querySelector('#hmc-s26');
    if (!section || section.dataset.r3Middle) return;
    var wrap = section.querySelector('.hmc-wrap');
    if (!wrap) return;
    var title = wrap.querySelector('h2');
    var image = wrap.querySelector('.hmc-imgcard');
    var copy = make('hmc-r3m-runner-copy');
    if (title) title.classList.add('hmc-r3m-runner-title');
    if (image) image.classList.add('hmc-r3m-runner-image');
    moveRest(wrap, copy, [title, image]);
    wrap.classList.add('hmc-r3m-runner-panel');
    if (title) wrap.appendChild(title);
    if (image) wrap.appendChild(image);
    wrap.appendChild(copy);
    section.dataset.r3Middle = 'runner';
  }

  window.HmcRound3Middle = function (root) {
    if (!root) return;
    setPhotoVariable(root, '--r3m-fibrin-photo', root.querySelector('#hmc-s20 img[src*="hm-pdp-study-2.jpg"]'));
    setPhotoVariable(root, '--r3m-japan-photo', root.querySelector('#hmc-s23 img'), 'hm-pdp-japan-bg.jpg');
    science(root);
    mechanism(root);
    failures(root);
    comparison(root);
    runner(root);
  };
}());

window.HmcRound3Top = function(root, sources, groups) {
  'use strict';
  var param = new URLSearchParams(location.search).get('design');
  var design = /^[abc]$/.test(param || '') ? param : 'a';
  root.classList.add('hmc-design-round3'); root.dataset.design = design;
  var $ = function(s, el){ return (el || root).querySelector(s); };
  if (!root.dataset.hmcServerLayout) {
  var made = $('.hmc-made-line'), pay = $('.hmc-pay'), atc = $('#hmcAtc');
  var trust = document.createElement('div'); trust.className = 'hmc-r3-trust';
  atc.after(trust);
  if(made) {
    made.classList.add('hmc-r3-shippingbar');
    var icon=document.createElement('span'); icon.className='hmc-r3-truck'; icon.setAttribute('aria-hidden','true');
    icon.innerHTML='<svg viewBox="0 0 28 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M2 4h15v14H2zM17 10h5l4 5v3h-9"/><circle cx="7" cy="19" r="3" fill="#f6f5f1"/><circle cx="22" cy="19" r="3" fill="#f6f5f1"/></svg>';
    made.prepend(icon); trust.appendChild(made);
  }
  if(pay) trust.appendChild(pay);
  ['.hmc-amz','.hmc-refill-line'].forEach(function(selector){var node=$(selector);if(node) trust.appendChild(node);});
  // Existing trust copy moves as intact nodes into the purchase column.
  if(sources[7]) trust.appendChild(sources[7]);
  if(sources[11]) trust.appendChild(sources[11]);
  // Manufacturing belongs to the full-width editorial flow, outside the constrained purchase column.
  if(sources[27]) root.insertBefore(sources[27],groups[6]);
  if(sources[21]) groups[6].appendChild(sources[21]);
  }
  // Empty structural wrappers have no visual footprint, without removing any source text.
  root.querySelectorAll('.hmc-rs-offer-details').forEach(function(el){if(!el.textContent.trim()) el.remove();});
  var videos = $('.hmc-vids',sources[21]);
  if(videos) {
    videos.classList.add('hmc-r3-videos');
    if(window.HmcRound3Carousel) window.HmcRound3Carousel(root,videos,{label:'Expert videos'});
    videos.querySelectorAll('video').forEach(function(video){
      var card=video.closest('.hmc-vid');
      var play=document.createElement('button');
      play.type='button'; play.className='hmc-r3-video-play'; play.dataset.round3Ui='';
      play.setAttribute('aria-label','Play video');
      play.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3v18l15-9z" fill="currentColor"/></svg>';
      play.addEventListener('click',function(){
        var playback=video.play();
        if(playback && playback.catch) playback.catch(function(){video.focus();});
      });
      card.appendChild(play);
      video.addEventListener('play',function(){video.closest('.hmc-vid').classList.add('is-playing');});
      video.addEventListener('pause',function(){video.closest('.hmc-vid').classList.remove('is-playing');});
    });
  }
  // The variant bar belongs only to this design-review preview; it changes no product copy.
  if(new URLSearchParams(location.search).get('review') === '1') {
    var bar=document.createElement('nav'); bar.className='hmc-r3-variantbar hmc-r3-controls'; bar.dataset.round3Ui='';
    bar.setAttribute('aria-label','Design variants');
    ['a','b','c'].forEach(function(letter){var a=document.createElement('a'); var url=new URL(location.href);url.searchParams.set('design',letter);url.searchParams.set('preview_theme_id',document.body.getAttribute('data-hm-theme'));a.href=url.href;a.textContent='Design '+letter.toUpperCase();a.setAttribute('aria-current',letter===design?'page':'false');bar.appendChild(a);});
    root.prepend(bar);
  }
};

/* Neutral PDP layout adapter. Moves existing nodes only; source copy and handlers stay intact. */
(function () {
  'use strict';

  var BLOCKS = [[1], [2, 3, 4], [5, 6, 8], [9, 10], [7, 11], [12, 27],
    [13, 19, 32], [14], [15], [16, 26], [17, 25], [18, 24], [20, 22],
    [21], [23], [28, 29, 30], [31], [33]];
  var EXCLUDE_AUDIT = '[data-round3-ui],.hmc-r3-controls,script,style,.hmc-pill,.hmc-rv-only,.t-mark,.t-neu,.t-note';
  var OPTIONAL_SOURCES = [13, 19, 32];

  function list(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function create(tag, className) {
    var node = document.createElement(tag);
    node.className = className;
    return node;
  }

  /* Order-independent text inventory: no copy is rewritten, deleted or cloned by this adapter. */
  function textInventory(containers) {
    var values = [];
    containers.forEach(function (container) {
      var walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      var node;
      while ((node = walker.nextNode())) {
        if (node.parentElement && node.parentElement.closest(EXCLUDE_AUDIT)) continue;
        var value = node.nodeValue.replace(/\s+/g, ' ').trim();
        if (value) values.push(value);
      }
    });
    return values.sort();
  }

  function fingerprint(values) {
    var text = JSON.stringify(values), hash = 2166136261;
    for (var i = 0; i < text.length; i++) {
      hash ^= text.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return ('00000000' + (hash >>> 0).toString(16)).slice(-8);
  }

  function markMoved(node, source) {
    node.setAttribute('data-rs-source', source);
    return node;
  }

  function init(root) {
    root = root || document.querySelector('.hmc[data-hmc]');
    if (!root || root.getAttribute('data-rs-ready') === 'true') return root && root.__hmcRestyleAudit;

    var sources = {}, missing = [];
    for (var i = 1; i <= 33; i++) {
      sources[i] = root.querySelector('#hmc-s' + i);
      if (i === 33 && !sources[i]) sources[i] = document.getElementById('hmc-s33');
      if (!sources[i] && OPTIONAL_SOURCES.indexOf(i) < 0) missing.push('hmc-s' + i);
    }
    var top = root.querySelector('#hmc-buy');
    var grid = root.querySelector('.hmc-top__grid');
    var head = root.querySelector('.hmc-top__head');
    var body = root.querySelector('.hmc-top__body');
    var atc = root.querySelector('#hmcAtc');
    var idOwner = document.getElementById('hmc-pdp');
    if (missing.length || !top || !grid || !head || !body || !atc || (idOwner && idOwner !== root)) {
      root.__hmcRestyleAudit = { pass: false, phase: 'preflight', missing: missing };
      console.warn('Holtmore restyle skipped: source structure does not match.', root.__hmcRestyleAudit);
      return root.__hmcRestyleAudit;
    }

    var footerOutside = sources[33] && !root.contains(sources[33]);
    var before = textInventory(footerOutside ? [root, sources[33]] : [root]);
    var controls = list('input,button,select,textarea,form,a', root);
    if (footerOutside) controls = controls.concat(list('input,button,select,textarea,form,a', sources[33]));

    root.id = 'hmc-pdp';
    root.classList.add('hmc-neutral-restyle');

    var groups;
    if (root.dataset.hmcServerLayout) {
      groups = BLOCKS.map(function (_ids, index) {
        return root.querySelector('[data-rs-block="' + (index + 1) + '"]');
      });
      if (groups.some(function (group) { return !group; })) {
        root.__hmcRestyleAudit = { pass: false, phase: 'server-groups' };
        return root.__hmcRestyleAudit;
      }
    } else {
      groups = BLOCKS.map(function (ids, index) {
      var block = create('div', 'hmc-rs-block');
      block.setAttribute('data-rs-block', String(index + 1));
      block.setAttribute('data-rs-sources', ids.join(','));
      return block;
    });

    root.insertBefore(groups[0], sources[1]);
    groups[0].appendChild(sources[1]);

    /* Existing grid areas and the gallery's nodes remain available to the base CSS/JS. */
    grid.insertBefore(groups[1], head);
    groups[1].appendChild(head);
    groups[1].appendChild(sources[4]);
    for (i = 2; i <= 5; i++) {
      body.appendChild(groups[i]);
      BLOCKS[i].forEach(function (id) { if (sources[id]) groups[i].appendChild(sources[id]); });
    }

    /* Keep modal, sticky and toast nodes as original root children after the content groups. */
    var tail = root.querySelector('.hmc-drawer-bg') || root.querySelector('[data-hmc-drawer]') || null;
    for (i = 6; i < BLOCKS.length; i++) {
      root.insertBefore(groups[i], tail);
      BLOCKS[i].forEach(function (id) { if (sources[id]) groups[i].appendChild(sources[id]); });
    }

    /* Only the first intro paragraph stays above the offer. Nothing is shortened. */
    var context = create('div', 'hmc-rs-context hmc-wrap hmc-body');
    Array.prototype.slice.call(sources[5].children).filter(function (node) {
      return node.tagName === 'P';
    }).slice(1).forEach(function (node) {
      context.appendChild(markMoved(node, 'hmc-s5'));
    });
    var cabinet = sources[6].querySelector('.hmc-cabinet');
    if (cabinet) context.appendChild(markMoved(cabinet, 'hmc-s6'));
    groups[7].appendChild(context);

    }

    /* Banners and detailed bonuses move below the main button; all remain visible.
       External labels continue to activate the original radio and its existing change handler. */
    var offerDetails = create('div', 'hmc-rs-offer-details');
    offerDetails.setAttribute('data-rs-source', 'hmc-s9');
    var ladder = sources[9].querySelector('.hmc-ladder');
    if (ladder) offerDetails.appendChild(markMoved(ladder, 'hmc-s9'));
    list('.hmc-offer', sources[9]).forEach(function (card) {
      var input = card.querySelector('input[type="radio"]');
      if (!input) return;
      var value = card.getAttribute('data-offer');
      if (value === '4') {
        var mid = card.querySelector('.hmc-offer__mid');
        var badges = create('div', 'hmc-rs-card-badges');
        var popular = card.querySelector('.hmc-offer__tags > span:not(.hmc-tag-red)');
        var freeShipping = card.querySelector('.hmc-ship-free');
        var gift = list('.hmc-vrow', card).filter(function (row) {
          return row.firstElementChild && row.firstElementChild.textContent.trim() === '+ FREE MYSTERY GIFT';
        })[0];
        [popular, freeShipping, gift].forEach(function (node) {
          if (node) { node.classList.add('hmc-rs-card-badge'); badges.appendChild(node); }
        });
        if (mid && badges.children.length) mid.appendChild(badges);
      }
      if (!input.id) input.id = 'hmc-rs-offer-' + value;
      var detail = create('label', 'hmc-rs-offer-detail');
      detail.htmlFor = input.id;
      detail.setAttribute('data-rs-offer', value);
      detail.setAttribute('data-rs-source', 'hmc-s9');
      Array.prototype.slice.call(card.children).forEach(function (node) {
        if (!node.matches('.hmc-offer__tags,.hmc-offer__extra,.hmc-spec')) return;
        if (node.textContent.trim()) detail.appendChild(node);
        else node.remove();
      });
      if (detail.children.length) offerDetails.appendChild(detail);
    });
    var refillLine = sources[10].querySelector('.hmc-refill-line');
    var detailsAnchor = refillLine || atc;
    detailsAnchor.parentNode.insertBefore(offerDetails, detailsAnchor.nextSibling);

    /* These are hooks only. Sample-review selection/labels belong to the separate build patch. */
    [13, 19, 32].forEach(function (id) {
      if (!sources[id]) return;
      sources[id].classList.add('hmc-rs-review-slot');
      sources[id].setAttribute('data-rs-review-slot', 's' + id);
    });
    list('.hmc-comment', sources[18]).forEach(function (node, index) {
      node.classList.add('hmc-rs-review-slot');
      node.setAttribute('data-rs-review-slot', 's18-quote-' + (index + 1));
    });

    if (window.HmcRound3Lower) window.HmcRound3Lower(root);
    if (window.HmcRound3Top) window.HmcRound3Top(root, sources, groups);
    if (window.HmcRound3Middle) window.HmcRound3Middle(root);
    if (window.HmcRound4) window.HmcRound4(root);
    var after = textInventory([root]);
    var audit = {
      phase: 'complete',
      pass: JSON.stringify(before) === JSON.stringify(after) && controls.every(function (node) { return root.contains(node); }),
      text_nodes_before: before.length,
      text_nodes_after: after.length,
      text_multiset_before: fingerprint(before),
      text_multiset_after: fingerprint(after),
      original_controls_preserved: controls.every(function (node) { return root.contains(node); }),
      blocks: groups.length,
      source_ids: Object.keys(sources).filter(function (id) { return !!sources[id]; }).map(function (id) { return sources[id].id; })
    };
    root.__hmcRestyleAudit = audit;
    root.__hmcRound3Audit = {pass:audit.pass, design:root.dataset.design, original_controls_preserved:audit.original_controls_preserved};
    root.setAttribute('data-rs-ready', 'true');
    root.setAttribute('data-rs-text-integrity', audit.pass ? 'pass' : 'fail');
    if (!audit.pass) console.error('Holtmore restyle text/control integrity failed.', audit);
    root.dispatchEvent(new CustomEvent('hmc:restyle-ready', { bubbles: true, detail: audit }));
    return audit;
  }

  window.HoltmoreNeutralRestyle = { init: init, blocks: BLOCKS };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
  else init();
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.matches && event.target.matches('.hmc[data-hmc]') ? event.target : event.target.querySelector('.hmc[data-hmc]');
    if (root) init(root);
  });
})();
